import { Box } from "@mui/material";
import { inAnimation } from "../../animations/animations";

export const NotFound = () => {
  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        animation: `${inAnimation} .5s cubic-bezier(.9,.1,.1,.9)`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: "primary.main",
        }}
      >
        <Box
          sx={{
            fontSize: "250px",
            fontWeight: "600",
          }}
        >
          404
        </Box>

        <Box>Page not found</Box>
      </Box>
    </Box>
  );
};
